import {
  Component,
  ElementRef,
  Input,
  OnChanges,
  SecurityContext,
  ViewChild,
} from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import isHtml from 'is-html';
import { DOMSerializer } from 'prosemirror-model';

import { schema } from '../setup/schema';
import { docFromJsonString } from '../util';

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'prosemirror-view',
  templateUrl: './prosemirror-view.component.html',
  styleUrls: ['./prosemirror-view.component.scss'],
})
export class ProsemirrorViewComponent implements OnChanges {
  @ViewChild('container', { static: true }) container: ElementRef;
  @Input() content: string;
  @Input() simplified = false;

  constructor(private domSanitizer: DomSanitizer) {}

  ngOnChanges() {
    if (isHtml(this.content)) {
      this.container.nativeElement.innerHTML = this.domSanitizer.sanitize(
        SecurityContext.HTML,
        this.content,
      );
      return;
    }
    const doc = docFromJsonString(schema, this.content);
    const fragment = DOMSerializer.fromSchema(schema).serializeFragment(
      doc.content,
    );
    this.container.nativeElement.innerHTML = '';
    this.container.nativeElement.appendChild(fragment);
  }
}
